import { createFeature, createReducer, on } from '@ngrx/store';

import { VendorManagementActions } from './vendor-management.actions';
import { initialVendorManagementState } from './vendor-management.state';

export const vendorManagementFeature = createFeature({
  name: 'vendorManagement',
  reducer: createReducer(
    initialVendorManagementState,
    on(VendorManagementActions.loadList, (state, { params }) => ({
      ...state,
      loadingList: true,
      error: null,
      listError: null,
      currentPage: params.page,
      pageSize: params.pageSize,
      listParams: params,
    })),
    on(
      VendorManagementActions.loadListSuccess,
      (state, { rows, total, page, pageSize, counts }) => ({
        ...state,
        rows,
        totalVendors: total,
        counts,
        currentPage: page,
        pageSize,
        loadingList: false,
        listError: null,
      }),
    ),
    on(VendorManagementActions.loadListFailure, (state, { error }) => ({
      ...state,
      rows: [],
      totalVendors: 0,
      loadingList: false,
      error,
      listError: error,
    })),
    on(VendorManagementActions.loadVendor, (state, { vendorId }) => ({
      ...state,
      loadingDetail: true,
      error: null,
      selectedVendorId: vendorId,
    })),
    on(VendorManagementActions.loadVendorSuccess, (state, { vendor }) => ({
      ...state,
      loadingDetail: false,
      selectedVendor: vendor,
      selectedVendorId: vendor.vendor_id,
    })),
    on(VendorManagementActions.loadVendorFailure, (state, { error }) => ({
      ...state,
      loadingDetail: false,
      error,
    })),
    on(VendorManagementActions.loadVendorPartners, (state, { params }) => ({
      ...state,
      loadingVendorPartners: true,
      vendorPartnerError: null,
      vendorPartnerPage: params.page,
      vendorPartnerPageSize: params.pageSize,
      vendorPartnerParams: params,
    })),
    on(
      VendorManagementActions.loadVendorPartnersSuccess,
      (state, { rows, total, page, pageSize }) => ({
        ...state,
        vendorPartnerRows: rows,
        vendorPartnerTotal: total,
        vendorPartnerPage: page,
        vendorPartnerPageSize: pageSize,
        loadingVendorPartners: false,
        vendorPartnerError: null,
      }),
    ),
    on(VendorManagementActions.loadVendorPartnersFailure, (state, { error }) => ({
      ...state,
      vendorPartnerRows: [],
      vendorPartnerTotal: 0,
      loadingVendorPartners: false,
      vendorPartnerError: error,
    })),
    on(
      VendorManagementActions.createVendor,
      VendorManagementActions.updateVendor,
      VendorManagementActions.updateVendorStatus,
      (state) => ({
        ...state,
        submitting: true,
        error: null,
        successMessage: null,
      }),
    ),
    on(VendorManagementActions.persistSuccess, (state, { message, vendor }) => ({
      ...state,
      submitting: false,
      successMessage: message,
      selectedVendor: vendor,
      selectedVendorId: vendor.vendor_id,
    })),
    on(VendorManagementActions.updateVendorStatusSuccess, (state, { message, vendor }) => ({
      ...state,
      submitting: false,
      successMessage: message,
      selectedVendor: vendor,
      selectedVendorId: vendor.vendor_id,
    })),
    on(
      VendorManagementActions.persistFailure,
      VendorManagementActions.updateVendorStatusFailure,
      (state, { error }) => ({
        ...state,
        submitting: false,
        error,
      }),
    ),
    on(VendorManagementActions.clearError, (state) => ({
      ...state,
      error: null,
      listError: null,
    })),
    on(VendorManagementActions.clearSuccessMessage, (state) => ({
      ...state,
      successMessage: null,
    })),
  ),
});

export const {
  name: vendorManagementFeatureKey,
  reducer: vendorManagementReducer,
  selectRows,
  selectCounts,
  selectTotalVendors,
  selectLoadingList,
  selectLoadingDetail,
  selectListError,
  selectSubmitting,
  selectError,
  selectSuccessMessage,
  selectSelectedVendor,
  selectSelectedVendorId,
  selectVendorPartnerRows,
  selectVendorPartnerTotal,
  selectLoadingVendorPartners,
  selectVendorPartnerError,
  selectVendorPartnerPage,
  selectVendorPartnerPageSize,
  selectCurrentPage,
  selectPageSize,
} = vendorManagementFeature;
